import Utils from 'common/scripts/utils';

class ObjectBanner {
    constructor() {
        this.state = false;
        this.activeClass = 'is-active';
    }

    init(element) {
        this.element = element;
        this.button = this.element.querySelector('.j-object-banner__button') || null;
        this.banner = this.element.querySelector('.j-object-banner__banner');
        this.overlay = this.element.querySelector('.j-object-banner__overlay');
        this.close = this.element.querySelector('.j-object-banner__close');

        this._bindEvents();
    }

    _bindEvents() {
        if (this.button) {
            this.element.addEventListener('click', (event) => {
                event.preventDefault();
            });
            this.button.addEventListener('click', this._openBanner.bind(this));
            this.overlay.addEventListener('click', this._closeBanner.bind(this));
            this.close.addEventListener('click', this._closeBanner.bind(this));

            const events = ['resize', 'orientationchange'];

            events.forEach((event) => {
                window.addEventListener(event, this._onResize.bind(this));
            });
        }
    }

    _openBanner(event) {
        event.preventDefault();
        Utils.bodyFixed(this.banner);
        this.banner.classList.add(this.activeClass);
        this.state = true;
    }

    _closeBanner(event) {
        event.preventDefault();
        this.banner.classList.remove(this.activeClass);
        this.state = false;
        setTimeout(() => {
            Utils.bodyStatic();
        }, 300);
    }

    _onResize(event) {
        if (this.state && this._isDesktop()) {
            this._closeBanner(event);
        }
    }

    /**
     * Определяет, десктоп или нет
     * @returns {boolean} - true - десктоп
     * @private
     */
    _isDesktop() {
        return Utils.isBreakpoint(1280, 10000);
    }
}

export default ObjectBanner;
